import React from "react";
import { Box, Button, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useTranslation } from "react-i18next";

const TouristTaxBanner = () => {
  const { t, i18n } = useTranslation();
  const pdfHref = i18n.language === "pt" ? "/tourist_tax_pt.pdf" : "/tourist_tax_en.pdf";

  return (
    <Box
      sx={{
        backgroundColor: "#1C2541",
        px: { xs: 2, md: 6 },
        py: { xs: 1.5, md: 1.5 },
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "center",
        gap: { xs: 1, sm: 3 },
      }}
    >
      {/* Line 1 on mobile: icon + title always together */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexGrow: 1 }}>
        <InfoOutlinedIcon sx={{ color: "#EE8013", fontSize: 24, flexShrink: 0 }} />
        <Typography
          variant="body2"
          sx={{ color: "white", fontWeight: 500, lineHeight: 1.4 }}
        >
          {t("touristTaxBannerTitle")}
        </Typography>
      </Box>

      {/* Line 2 on mobile: button aligned left under the text */}
      <Button
        component="a"
        href={pdfHref}
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        startIcon={<PictureAsPdfIcon />}
        size="small"
        sx={{
          backgroundColor: "#EE8013",
          color: "white",
          fontWeight: "bold",
          whiteSpace: "nowrap",
          flexShrink: 0,
          alignSelf: { xs: "flex-start", sm: "center" },
          ml: { xs: 4, sm: 0 },
          "&:hover": { backgroundColor: "#d4720f" },
        }}
      >
        {t("touristTaxBannerCta")}
      </Button>
    </Box>
  );
};

export default TouristTaxBanner;
